import logEvent from 'analytics/logEvent';
import cn from 'classnames';
import React from 'react';

import { UrlService } from 'domains/common/url';

import ALink from 'components/basic/ALink';
import Icon, { IconTypes } from 'components/basic/Icon';
import { BodyM } from 'components/basic/Typography';

import { useAppDispatch, useAppSelector } from 'redux-store';
import logoutThunk from 'redux-store/thunks/profile/logoutThunk';

import s from './MenuItems.module.scss';

const urlAppService = new UrlService({ main: false });

export default function MenuItems(): JSX.Element {
  const dispatch = useAppDispatch();
  const { isAuthenticated } = useAppSelector(state => {
    return state.profile;
  });

  return (
    <div className={s.wrapper}>
      <ALink
        href="https://help.welltory.com/"
        className={cn(s.menuItem, 'cy-menu-help-lik')}
        target="_blank"
        onClick={(): void =>
          logEvent('Web_Header_Menu_Link_Clicked', {
            link_id: 'help',
          })
        }
      >
        <Icon
          className={s.icon}
          icon={IconTypes.question}
          color="white"
          size={24}
        />
        <BodyM>Help</BodyM>
      </ALink>
      {isAuthenticated &&
        <ALink
          href={urlAppService.getUrl('/user/profile')}
          className={cn(s.menuItem, 'cy-menu-help-lik')}
          onClick={(): void =>
            logEvent('Web_Header_Menu_Link_Clicked', { link_id: 'user_profile' })
          }
        >
          <Icon
            className={s.icon}
            icon={IconTypes.arrowBack}
            color="white"
            size={24}
          />
          <BodyM>My profile</BodyM>
        </ALink>
      }
      {isAuthenticated && (
        <>
          <hr className={s.divider} />
          <div
            onClick={(): void => {
              logEvent('Web_Header_Menu_Link_Clicked', {
                link_id: 'logout',
              });
              dispatch(logoutThunk());
            }}
            className={cn(s.menuItem, 'cy-menu-logout-button')}
          >
            <Icon
              className={s.icon}
              icon={IconTypes.logout}
              color="white"
              size={24}
            />
            <BodyM>Log out</BodyM>
          </div>
        </>
      )}
    </div>
  );
}
